export default __webpack_public_path__ + "6cdb87023e253659c4ea891efa85daf0.woff";